module.exports = __webpack_public_path__ + "img/logo.836a4822.png";